<template>
  <div class="hello">
    <template v-if="checkWidth > 500">
      <template v-for="item in cardContent">
        <CRow :key="item.id" align-vertical="start" v-if="item.position === 0">
          <CCol xl="5" lg="5" md="12" sm="12" v-if="item.position === 0">
            <div class="talk-bubble-gray tri-right round left-in">
              <div class="talktext">
                <p :class="checkLangClass()+' '+'chat-text'">{{checkLanguage(item.message)}}</p>
              </div>
            </div>
          </CCol>
        </CRow>
        <CRow
          :key="item.id"
          align-vertical="start"
          align-horizontal="end"
          class="mr-0 mb-3"
          v-if="item.position === 1"
        >
          <CCol
            :xl="{ size: '5', offset:'6' }"
            :lg="{ size: '5', offset:'6' }"
            :md="{ size: '12', offset:'6' }"
            :sm="{ size: '12', offset:'6' }"
            style="display: flex; justify-content: flex-end"
          >
            <div class="talk-bubble-blue tri-right round right-in">
              <div class="talktext">
                <p :class="checkLangClass()+' '+'chat-text'">{{checkLanguage(item.message)}}</p>
              </div>
            </div>
          </CCol>
        </CRow>
      </template>
    </template>

    <template v-if="checkWidth <= 500">
      <template v-for="item in cardContent">
        <CRow :key="item.id" align-vertical="start" v-if="item.position === 0">
          <CCol xl="5" lg="5" md="12" sm="12" v-if="item.position === 0">
            <div class="talk-bubble-gray tri-right round left-in">
              <div class="talktext">
                <p
                  :class="checkLangClass()+' '+'chat-text'"
                  style="font-size: 12px;"
                >{{checkLanguage(item.message)}}</p>
              </div>
            </div>
          </CCol>
        </CRow>
        <CRow
          :key="item.id"
          align-vertical="start"
          align-horizontal="end"
          class="mr-0 mb-3"
          v-if="item.position === 1"
        >
          <CCol
            :xl="{ size: '5', offset:'6' }"
            :lg="{ size: '5', offset:'6' }"
            :md="{ size: '12', offset:'6' }"
            :sm="{ size: '12', offset:'6' }"
            style="display: flex; justify-content: flex-end"
          >
            <div class="talk-bubble-blue tri-right round right-in">
              <div class="talktext">
                <p :class="checkLangClass()+' '+'chat-text'" style="font-size: 12px;">{{checkLanguage(item.message)}}</p>
              </div>
            </div>
          </CCol>
        </CRow>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "../../../assets/css/chatBubble.css";
export default {
  components: {},
  name: "Chat",
  props: {
    cardContent: Array,
    checkWidth: String,
  },
  data() {
    return {
      lang: "",
    };
  },
  computed: {
    ...mapGetters({
      getLanguage: "language/getLanguage",
    }),
  },
  watch: {
    getLanguage: function (val) {
      this.lang = val;
    },
  },

  mounted() {},

  created() {
    this.lang = this.$store.state.language.language;
  },

  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
      }
    },
  },
};
</script>

<style scoped>
.imgTest {
  width: 100%;
  height: 100%;
  margin-bottom: 7px;
}

.ConverUser {
  width: 4rem;
  height: 4rem;
  border-radius: 60px;
  border-color: black;
  border: 2px solid;
  display: flex;
  justify-content: center;
  align-items: center;
}

.left-message {
  width: fit-content;
  height: 100%;
  border-radius: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: lightgray;
  color: black;
  /* margin-left: auto; */
  /* margin-right: auto; */
  /* background-color: black; */
}

.right-message {
  width: fit-content;
  height: 100%;
  border-radius: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #2c8dfb;
  color: white;
  margin-left: auto;
  /* background-color: black; */
}

.rightConver {
  width: 100%;
  display: flex;
  justify-content: flex-end !important;
  /* margin-top: 2%; */
}

.Left-convo {
  justify-content: flex-start;
  margin-bottom: 2%;
}
</style>